import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import api from "../../api/axios";
import { IApiResponseError, IGenericApiState } from "../../types/api";

interface IBulkRefundTransactionResponse {
  status: boolean;
  message: string;
  statusCode: string;
  errors: IApiResponseError[];
}

const initialState: IGenericApiState<IBulkRefundTransactionResponse> = {
  data: null,
  status: "idle",
  error: "",
};

export const bulkRefundTransactionAsync = createAsyncThunk(
  "bulkRefundTransaction",
  async (transactionIds: string[], { rejectWithValue }) => {
    try {
      const { data } = await api.post(
        `/virtual-account/transactions/bulk-refund`,
        transactionIds,
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IBulkRefundTransactionResponse>;
      return rejectWithValue(error.response?.data);
    }
  },
);

export const bulkRefundTransactionSlice = createSlice({
  name: "bulkRefundTransaction",
  initialState,
  reducers: {
    bulkRefundTransactionReset: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(bulkRefundTransactionAsync.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(bulkRefundTransactionAsync.fulfilled, (state, action) => {
        state.status = "success";
        state.data = action.payload as IBulkRefundTransactionResponse;
      })
      .addCase(bulkRefundTransactionAsync.rejected, (state, action) => {
        state.status = "failed";
        state.data = action.payload as IBulkRefundTransactionResponse;
        state.error = action.error.message;
      });
  },
});

export const { bulkRefundTransactionReset } =
  bulkRefundTransactionSlice.actions;

export default bulkRefundTransactionSlice.reducer;
